export const servicesData = [{
    icon: "🧭",
    title: "Conseil en Gestion",
    description: "Pilotez efficacement votre organisation avec des outils de gestion adaptés",
    features: [
        "Diagnostic organisationnel",
        "Appui à la prise de décision stratégique",
        "Élaboration dse plans d'optimisation",
        "Mise en place d'outils de suivi opérationnel"
    ]
},
{
    icon: "💰",
    title: "Analyse des Coûts",
    description: "Maîtrisez vos budgets en anticipant les charges et les ressources nécessaires",
    features: [
        "📊 Analyse des coûts de fonctionnement",
        "🧮 Estimation budgétaire des projets",
        "📉 Simulation financière",
        "📌 Études de faisabilité économiques"
    ]
}, {
    icon: "✂️",
    title: "Maîtrise & réduction des coûts",
    description: "Réduisez vos charges sans sacrifier la performance de vos équipes ou services",
    features: [
        "🔍 Audit des dépenses et charges fixes",
        "🛠 Refonte des processus internes",
        "🎯 Plan d’optimisation des coûts",
        "📈 Suivi des gains obtenus"
    ]
}, {
    icon: "🗂",
    title: "Assistance administrative",
    description: "Renforcez la fluidité et la rigueur de vos fonctions supports",
    features: [
        "🧾 Organisation des tâches administratives",
        "📁 Gestion documentaire et archivage",
        "🕒 Suivi des obligations réglementaires",
        "🖊 Appui au secrétariat exécutif"
    ]
}, {
    icon: "⚖️",
    title: "Accompagnement juridique ",
    description: "Assurez la conformité de votre structure dans un cadre réglementaire complexe",
    features: [
        "📚 Conseil en droit OHADA et droit local",
        "📄 Rédaction & révision de contrats",
        "🧷 Appui aux démarches légales",
        "🚨 Prévention des risques juridiques"
    ]
}, {
    icon: "🏛",
    title: "Administration de gestion",
    description: "Structurez votre fonctionnement interne avec une organisation adaptée",
    features: [
        "🧩 Mise en place de procédures internes",
        "📌 Appui à la gestion quotidienne",
        "📊 Suivi des tableaux de bord",
        "🤝 Interface avec les partenaires institutionnels"
    ]
}, {
    icon: "🧾",
    title: "Appui à la fonction financière & comptable",
    description: "Sécurisez vos comptes et optimisez la gestion de vos flux financiers",
    features: [
        "🧮 Tenue de comptabilité générale & analytique",
        "📑 Élaboration des états financiers",
        "🔄 Appui à la clôture périodique",
        "🧷 Préparation à l’audit ou au contrôle externe"
    ]
}
]